import {
  enumKeySource,
  kBackspaceKey,
  kDeleteKey,
  kDownArrow,
  kEscKey,
  kF12Key,
  kF1Key,
  kLeftArrow,
  kReturnKey,
  kRightArrow,
  kTabKey,
  kUpArrow
} from "../constants";

export function HandleFireFoxKeyEvent(event, kInfo) {
  kInfo.keyCode = event.keyCode;
  kInfo.charCode = event.charCode;
  kInfo.ctrlKey = event.ctrlKey;
  kInfo.shiftKey = event.shiftKey;
  kInfo.altKey = event.altKey;
  kInfo.metaKey = event.metaKey;

  if (kInfo.source == enumKeySource.keyPress) {
    kInfo.ignoreEvent = false;
    switch (kInfo.keyCode) {
      case kTabKey:
      case kReturnKey:
        //case kDeleteKey:
        kInfo.charCode = kInfo.keyCode;
        break;
      case kF1Key:
      case kF12Key:
        if (event.key == "F1" || event.key == "F12") {
          kInfo.funcKey = true;
          break;
        }
      default:
        if (kInfo.charCode != 0) kInfo.keyCode = 0;
    }
    //console.log("KeySource - keypress: KeyCode:", k.keyCode, " CharCode:", k.charCode, " Ignore:", k.ignoreEvent);
  } else if (kInfo.source == enumKeySource.keyDown) {
    //kInfo.ignoreEvent = false;
    switch (kInfo.keyCode) {
      case kTabKey:
      case kReturnKey:
      case kDeleteKey:
      case kBackspaceKey:
        kInfo.charCode = kInfo.keyCode;
        kInfo.ignoreEvent = false;
        break;
      case kEscKey:
      case kLeftArrow:
      case kUpArrow:
      case kRightArrow:
      case kDownArrow:
        kInfo.ignoreEvent = false;
        break;
      case kF1Key:
      case kF12Key:
        kInfo.funcKey = true;
        kInfo.ignoreEvent = false;
        break;
      default:
    }
  }
}
